module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1bPqP"))).then(() => module.bundle.root('aVi2q'));